import { Component, Input, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '../common.service';
import { GoogleAnalyticsService } from '../google-analytics.service';
import { EntryStatusComponent } from '../entry-status/entry-status.component';
import { SequenceCardComponent } from '../sequence-card/sequence-card.component';
import { Subscription } from 'rxjs/internal/Subscription';
import { PlatformService } from '../platform.service';
import { PROVIDER_MAP, ProviderData } from '../entry/structure-data.models';
import { ConfigService } from '../config.service';

@Component({
    selector: 'search-result-card',
    templateUrl: './search-result-card.component.html',
    styleUrls: ['./search-result-card.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SearchResultCardComponent implements OnInit {

  @Input() resultRec: any;
  //@Input() isSequenceSearch: boolean;
  @Input() resultRecIndex: number;
  kbCount: number;
  isSequenceSearch: boolean = false;
  routeSubscriber: Subscription;
  dropdownOptions: { label: string, value: any, isShow: boolean }[];

  constructor(private changeDetectorRef: ChangeDetectorRef, public commonService: CommonService, public router: Router, public gaService: GoogleAnalyticsService, 
  private configService: ConfigService,
  private route: ActivatedRoute,  private platform: PlatformService) { }

  @Input() isSelected: boolean = false;
  @Input() disabled: boolean = false;
  @Input() isLimitReached: boolean = false;
  
  @Output() selectionChanged = new EventEmitter<{ value: string, selected: boolean }>();
  public isBrowser: boolean = false;
  public providerData = { providerName: '' }; 
  public providerName:string = "";
  notifySelectionChange(event: Event) {
    const checkbox = event.target as HTMLInputElement;
    this.selectionChanged.emit({ value: checkbox.value, selected: checkbox.checked });
  }

  ngOnInit(): void {
     this.isBrowser = this.platform.isBrowserPlatform()
    //Get structure count in PDBe-KB
    const apiUrl = `https://www.ebi.ac.uk/pdbe/search/pdb/select?group=true&group.field=pdb_id&group.ngroups=true&rows=0&omitHeader=true&json.nl=map&q=uniprot_accession:${this.resultRec.uniprotAccession}&wt=json`;
    this.commonService.getApiData(apiUrl).subscribe(apiData => {
      if(apiData && apiData.grouped && apiData.grouped.pdb_id) {
        this.kbCount = apiData.grouped.pdb_id.ngroups;
        this.changeDetectorRef.detectChanges();
      }
    });

    this.providerName = PROVIDER_MAP[this.resultRec.providerId];
    // this.providerData = {
    //   providerName: providerName?? 'Unknown Provider'
    // }
    this.routeSubscriber = this.route.params.subscribe(params => {
      if(params.field === "sequence"){
        this.isSequenceSearch = true;
      }
    });
  }

  // getProviderName(){
  //   const providerName = PROVIDER_MAP[this.resultRec.providerId];
  //   this.providerData = {
  //     providerName: providerName?? 'Unknown Provider'
  //   }
  // }

  generate_download_accessions(entry: string): string {
    return entry;
  }
  
  getPlddtLevel(plddt: number): string {
    return plddt > 90 ? 'Very High' :
           plddt > 70 ? 'High' :
           plddt > 50 ? 'Low' :
           'Very Low';
  }
  ngOnDestroy(): void {
    this.routeSubscriber.unsubscribe();
  }
}
